import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34e4962c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "boxed-container text-center mt-16"
}
const _hoisted_2 = {
  key: 1,
  class: "boxed-container text-center"
}
const _hoisted_3 = {
  key: 0,
  style: {"color":"#a9a9a9"},
  class: "mb-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!$setup.isReadonly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_ion_button, {
            fill: "clear",
            color: "danger",
            class: "d-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($props.fragenblock.getTitle()) + " " + _toDisplayString($setup.t("hzba.buttons.loeschen")), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (!$setup.isReadonly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_ion_button, {
            fill: "clear",
            color: "info",
            class: "d-button",
            disabled: $props.fragenblock.isFormDirty(),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('duplicate')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($props.fragenblock.getTitle()) + " " + _toDisplayString($setup.t("hzba.buttons.duplizieren")), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          ($props.fragenblock.isFormDirty())
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($setup.t("hzba.duplizierenInfoText")), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}